import React from 'react'
import { useForm } from 'react-hook-form'
import { IUser } from '@verzekeringapp-mono/shared/src/models/user'
import Button from '~/components/Button'

type Props = Partial<
  Pick<IUser, 'email' | 'firstName' | 'middleName' | 'lastName'>
> & {
  onSubmit: (data: {
    email: string
  }) => void
  formType: 'create' | 'edit'
  isLoading?: boolean
  error?: string | null
}

const MemberForm = ({
  email,
  onSubmit,
  formType,
  isLoading,
  error
}: Props) => {
  const { register, handleSubmit, formState: { isValid } } = useForm({
    defaultValues: {
      email
    }
  })

  return (
    <div className='flex flex-col gap-4 rounded bg-surface-page p-8'>
      <div className='flex flex-col lg:w-1/2 w-full'>
        <form
          className='flex flex-col gap-8'
          onSubmit={handleSubmit(data =>
            onSubmit({
              email: data.email || ''
            })
          )}
        >
          {formType === 'create' && (
            <div>
              <label
                htmlFor='email'
                className='label mt-4'
              >
                E-mailadres
              </label>

              <input
                className='textfield mt-2'
                type='email'
                id='email'
                placeholder='E-mailadres'
                {...register('email', { required: true, pattern: /^\S+@\S+$/i })}
              />
            </div>
          )}

          {error && <p className='text-status-danger-foreground'>{error}</p>}

          <Button
            type='submit'
            isLoading={isLoading}
            className={
              'w-full rounded-md bg-action-primary-background text-action-primary-foreground hover:bg-opacity-80'
            }
            disabled={isLoading || !isValid}
          >
            {formType === 'create'
              ? (
                <p className='text-action-primary-foreground'>Gebruiker uitnodigen</p>
              )
              : (
                <p className='text-action-primary-foreground'>Wijzigingen opslaan</p>
              )}
          </Button>
        </form>
      </div>
    </div>
  )
}

export default MemberForm
